<template>
    <vx-card class="" style="">
            <div class="">
                <vs-row>
                    <vs-col
                        v-for="(image, index) in getSpecImage"
                        :key="index"
                        class="w-1/2"
                    >
                        <div
                            class="imageBox p-2 m-2"
                            :class="{
                                'imageBox-active':
                                    selectedImage.name == image.name,
                            }"
                        >
                            <img
                                @click="chooseImage(image)"
                                :src="image.image"
                                alt=""
                                style="width: 100%;"
                            />
                        </div>
                    </vs-col>
                </vs-row>
            </div>
        <template #footer>
            <div class="btn flex justify-end w-full p-3">
                <vs-button @click="saveClickHandler(selectedImage)">
                    <span>{{ $t("select") }}</span>
                </vs-button>
            </div>
        </template>
    </vx-card>
</template>

<script>
// import Popup from "./Popup.vue";
import {mapActions, mapGetters} from "vuex";

export default {
    // components: { Popup },
    props: {
        active: {
            type: Boolean,
        },
        title: {
            type: String,
            default: "Картинки",
        },
        data: {
            type: Array,
        },
        data_image:[]
    },
    data() {
        return {
            selectedImage: {
                name: "",
            },
        };
    },
    async created() {
        await this.getSpecImages()
    },
    computed: {
        ...mapGetters({
            getSpecImage: "system_settings/getSpecImage",
        }),
    },
    methods: {
        ...mapActions({
            getSpecImages: "system_settings/getSpecImages",
        }),
        chooseImage(img) {
            this.selectedImage = img;
        },
        saveClickHandler(image) {
            this.$emit("save", { image });
        },
        cancelHandler() {
            this.$emit("close");
        },
    },
};
</script>

<style>
.imageBox {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
}
.imageBox-active {
    border-radius: 5px;
    border: solid 1px #545da7;
    background-color: #f2f1f2;
}
</style>
